function getDomain() {
  const currentUrl = window.location.href;
  let domain;

  if (currentUrl.includes('paymentuiqa') ) {
    domain = 'https://paymentqa.policybazaar.com';
  } else if(currentUrl.includes('localhost')){
    domain = 'http://localhost:8080';
  } else {
    domain = 'https://payment.policybazaar.com';
  }

  return domain;
}

export default getDomain;

